import { useState } from 'react';

export const useInvoicePaymentConfig = () => {
  const [config] = useState(() => {
    const mountElement = document.getElementById('portal-invoice-payment-root');

    return {
      addressProfile: mountElement?.dataset.addressProfile || '',
      addressLookupKey: mountElement?.dataset.addressLookupKey || '',
      amount: mountElement?.dataset.amount || '',
      invoiceId: mountElement?.dataset.invoiceId || '',
      invoiceNumber: mountElement?.dataset.invoiceNumber || '',
      countryCode: mountElement?.dataset.countryCode || 'gb',
      email: mountElement?.dataset.email || '',
      name: mountElement?.dataset.name || '',
      addressLine1: mountElement?.dataset.addressline1 || '',
      addressLine2: mountElement?.dataset.addressline2 || '',
      addressLine3: mountElement?.dataset.addressline3 || '',
      town: mountElement?.dataset.town || '',
      city: mountElement?.dataset.city || '',
      postcode: mountElement?.dataset.postcode || '',
      successUrl: mountElement?.dataset.successUrl || '',
      declinedUrl: mountElement?.dataset.declinedUrl || '',
      returnUrl: mountElement?.dataset.returnUrl || '',
      labels: {
        addressTabHeading: mountElement?.dataset.addressTabHeading || 'Billing address',
        paymentTabHeading: mountElement?.dataset.paymentTabHeading || 'Payment',
        contactSectionHeading: mountElement?.dataset.contactSectionHeading || 'Contact details',
        addressSectionHeading: mountElement?.dataset.addressSectionHeading || 'Billing address',
        nameLabel: mountElement?.dataset.nameLabel || 'Full name',
        emailLabel: mountElement?.dataset.emailLabel || 'Email address',
        paymentDeclinedHeading: mountElement?.dataset.paymentDeclinedHeading || 'Payment declined',
        paymentDeclinedMessage:
          mountElement?.dataset.paymentDeclinedMessage ||
          'Please ensure the payment details you enter are correct or try another card.',
        paymentErrorHeading: mountElement?.dataset.paymentErrorHeading || 'An error has occurred',
        paymentErrorMessage:
          mountElement?.dataset.paymentErrorMessage ||
          'Please try again or get in touch with a member of our team if the issue persists.',
        cancelButtonLabel: mountElement?.dataset.cancelButtonLabel || 'Cancel',
      },
    };
  });
  return config;
};
